import { render, staticRenderFns } from "./BaseOrderCard.vue?vue&type=template&id=0b3c1d6d&scoped=true&"
import script from "./BaseOrderCard.vue?vue&type=script&lang=js&"
export * from "./BaseOrderCard.vue?vue&type=script&lang=js&"
import style0 from "./BaseOrderCard.vue?vue&type=style&index=0&id=0b3c1d6d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3c1d6d",
  null
  
)

export default component.exports